import { render, staticRenderFns } from "./TabNDV.vue?vue&type=template&id=35a4a74a&"
import script from "./TabNDV.vue?vue&type=script&lang=ts&"
export * from "./TabNDV.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('35a4a74a', component.options)
    } else {
      api.reload('35a4a74a', component.options)
    }
    module.hot.accept("./TabNDV.vue?vue&type=template&id=35a4a74a&", function () {
      api.rerender('35a4a74a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/TabsModals/TabNDV.vue"
export default component.exports